import React from 'react';

const Modal = ({ isOpen, onClose, title, children, imageSrc }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 transition-opacity duration-300 ease-in-out px-4 py-8"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 sm:p-8 rounded-xl shadow-2xl w-full max-w-xl relative z-50 transform transition-all duration-300 ease-out scale-95 opacity-0 animate-modal-appear"
        style={{ animation: 'modal-appear 0.3s ease-out forwards' }}
      >
        <div className="flex justify-between items-center mb-5 border-b border-gray-200 pb-3">
          <h2 className="text-2xl font-serif font-bold text-red-800">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-700 transition duration-150 ease-in-out p-1 rounded-full hover:bg-gray-100"
            aria-label="Stäng modal"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>
        {imageSrc && (
          <div className="mb-4">
            <img src={imageSrc} alt={title} className="w-full h-auto max-h-60 object-cover rounded-md" />
          </div>
        )}
        <div className="text-gray-800 max-h-[65vh] overflow-y-auto pr-3 custom-scrollbar font-sans">
          {children}
        </div>
      </div>
      <style>{`
        @keyframes modal-appear { to { transform: scale(1); opacity: 1; } }
        .custom-scrollbar::-webkit-scrollbar { width: 8px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #c5c5c5; border-radius: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }
      `}</style>
    </div>
  );
};

export default Modal;